import { capitalizeFirstLetter, splitCamelCaseWithAbbreviations } from "./strings"

export const getTableHeader = (header: string): string => {
    const split = splitCamelCaseWithAbbreviations(header)
    const capitalized = split.map(s => capitalizeFirstLetter(s))
    const result = capitalized.join(" ")
    return result
}

export declare type AlignType = 'left' | 'center' | 'right';

export const getTDAlign = (isDate: boolean): AlignType => {
    if (isDate) return "left"
    return "center"
}